import React from 'react';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import BrowseEntitiesSkeleton from 'components/data-containers/BrowseEntities/SkeletonLoader';
import { EntityContext } from 'context/entityContext';

const BrowseEntity = React.lazy(() =>
  import('components/data-containers/BrowseEntities/BrowseEntity')
);

const Discoveries: React.FC = () => {
  const ctx = React.useContext(EntityContext);
  const { compareMode, entityType } = ctx;

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      {!compareMode && (
        <React.Suspense
          fallback={
            <BrowseEntitiesSkeleton
              title="Browse Tracks"
              browseEntityType="track"
              enableSearch
            />
          }
        >
          <BrowseEntity {...ctx} id="browse-tracks" browseEntityType="track" />
        </React.Suspense>
      )}

      {compareMode && (
        <Layout.MaxWidth>
          <Message data-pw="MessageBlock">
            Shazam browse tracks is not available in compare mode. Exit compare
            mode to see Shazam tags for this {entityType}.
          </Message>
        </Layout.MaxWidth>
      )}

      <Layout.MaxWidth>
        <Message data-pw="MessageBlock">
          Shazam data is not available for projects. Select a track to see
          related discovery data.
        </Message>
      </Layout.MaxWidth>
    </div>
  );
};

export default Discoveries;
